import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, unref as _unref, renderList as _renderList, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "home-wage-report-modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "header-actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "table-wrapper" }
const _hoisted_7 = { class: "home-wage-report-table" }
const _hoisted_8 = { class: "header-row-1" }
const _hoisted_9 = ["colspan"]
const _hoisted_10 = ["colspan"]
const _hoisted_11 = ["colspan"]
const _hoisted_12 = { class: "header-row-2" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "nontax-col"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 5 }
const _hoisted_22 = { key: 6 }
const _hoisted_23 = { key: 7 }
const _hoisted_24 = { key: 8 }
const _hoisted_25 = { key: 9 }
const _hoisted_26 = { key: 10 }
const _hoisted_27 = { key: 11 }
const _hoisted_28 = { key: 12 }
const _hoisted_29 = { key: 13 }
const _hoisted_30 = { key: 14 }
const _hoisted_31 = { key: 15 }
const _hoisted_32 = { key: 16 }
const _hoisted_33 = { key: 17 }
const _hoisted_34 = { key: 18 }
const _hoisted_35 = { key: 19 }
const _hoisted_36 = { key: 20 }
const _hoisted_37 = { key: 21 }
const _hoisted_38 = { key: 22 }
const _hoisted_39 = { key: 23 }
const _hoisted_40 = { key: 24 }
const _hoisted_41 = { key: 25 }
const _hoisted_42 = { key: 26 }
const _hoisted_43 = { key: 27 }
const _hoisted_44 = { key: 28 }
const _hoisted_45 = { key: 29 }
const _hoisted_46 = { key: 30 }
const _hoisted_47 = { class: "center" }
const _hoisted_48 = { class: "center" }
const _hoisted_49 = { class: "center" }
const _hoisted_50 = { class: "center" }
const _hoisted_51 = { class: "right" }
const _hoisted_52 = { class: "right" }
const _hoisted_53 = { class: "right" }
const _hoisted_54 = { class: "right" }
const _hoisted_55 = {
  key: 0,
  class: "right"
}
const _hoisted_56 = {
  key: 1,
  class: "right"
}
const _hoisted_57 = {
  key: 2,
  class: "right"
}
const _hoisted_58 = {
  key: 0,
  class: "right"
}
const _hoisted_59 = {
  key: 1,
  class: "right nontax-col"
}
const _hoisted_60 = {
  key: 0,
  class: "right"
}
const _hoisted_61 = {
  key: 1,
  class: "right"
}
const _hoisted_62 = {
  key: 2,
  class: "right"
}
const _hoisted_63 = {
  key: 5,
  class: "right"
}
const _hoisted_64 = {
  key: 6,
  class: "right"
}
const _hoisted_65 = {
  key: 7,
  class: "right"
}
const _hoisted_66 = {
  key: 8,
  class: "right"
}
const _hoisted_67 = {
  key: 9,
  class: "right"
}
const _hoisted_68 = {
  key: 10,
  class: "right"
}
const _hoisted_69 = {
  key: 11,
  class: "right"
}
const _hoisted_70 = {
  key: 12,
  class: "right"
}
const _hoisted_71 = {
  key: 13,
  class: "right"
}
const _hoisted_72 = {
  key: 14,
  class: "right"
}
const _hoisted_73 = ["title"]
const _hoisted_74 = {
  key: 15,
  class: "right"
}
const _hoisted_75 = {
  key: 16,
  class: "right"
}
const _hoisted_76 = {
  key: 17,
  class: "right"
}
const _hoisted_77 = {
  key: 18,
  class: "right"
}
const _hoisted_78 = {
  key: 19,
  class: "right"
}
const _hoisted_79 = {
  key: 20,
  class: "right"
}
const _hoisted_80 = {
  key: 21,
  class: "right"
}
const _hoisted_81 = {
  key: 22,
  class: "right"
}
const _hoisted_82 = {
  key: 23,
  class: "right"
}
const _hoisted_83 = ["title"]
const _hoisted_84 = { class: "right net-col" }
const _hoisted_85 = {
  key: 24,
  class: "right"
}
const _hoisted_86 = {
  key: 25,
  class: "right"
}
const _hoisted_87 = {
  key: 26,
  class: "right"
}
const _hoisted_88 = {
  key: 27,
  class: "right"
}
const _hoisted_89 = {
  key: 28,
  class: "right"
}
const _hoisted_90 = {
  key: 29,
  class: "right"
}
const _hoisted_91 = {
  key: 30,
  class: "right"
}
const _hoisted_92 = ["title"]
const _hoisted_93 = { class: "total-row" }
const _hoisted_94 = { class: "right" }
const _hoisted_95 = {
  key: 0,
  class: "right"
}
const _hoisted_96 = {
  key: 1,
  class: "right"
}
const _hoisted_97 = {
  key: 2,
  class: "right"
}
const _hoisted_98 = {
  key: 0,
  class: "right"
}
const _hoisted_99 = {
  key: 1,
  class: "right nontax-col"
}
const _hoisted_100 = {
  key: 0,
  class: "right"
}
const _hoisted_101 = {
  key: 1,
  class: "right"
}
const _hoisted_102 = {
  key: 2,
  class: "right"
}
const _hoisted_103 = {
  key: 5,
  class: "right"
}
const _hoisted_104 = {
  key: 6,
  class: "right"
}
const _hoisted_105 = {
  key: 7,
  class: "right"
}
const _hoisted_106 = {
  key: 8,
  class: "right"
}
const _hoisted_107 = {
  key: 9,
  class: "right"
}
const _hoisted_108 = {
  key: 10,
  class: "right"
}
const _hoisted_109 = {
  key: 11,
  class: "right"
}
const _hoisted_110 = {
  key: 12,
  class: "right"
}
const _hoisted_111 = {
  key: 13,
  class: "right"
}
const _hoisted_112 = {
  key: 14,
  class: "right"
}
const _hoisted_113 = ["title"]
const _hoisted_114 = {
  key: 15,
  class: "right"
}
const _hoisted_115 = {
  key: 16,
  class: "right"
}
const _hoisted_116 = {
  key: 17,
  class: "right"
}
const _hoisted_117 = {
  key: 18,
  class: "right"
}
const _hoisted_118 = {
  key: 19,
  class: "right"
}
const _hoisted_119 = {
  key: 20,
  class: "right"
}
const _hoisted_120 = {
  key: 21,
  class: "right"
}
const _hoisted_121 = {
  key: 22,
  class: "right"
}
const _hoisted_122 = {
  key: 23,
  class: "right"
}
const _hoisted_123 = ["title"]
const _hoisted_124 = { class: "right net-col" }
const _hoisted_125 = {
  key: 24,
  class: "right"
}
const _hoisted_126 = {
  key: 25,
  class: "right"
}
const _hoisted_127 = {
  key: 26,
  class: "right"
}
const _hoisted_128 = {
  key: 27,
  class: "right"
}
const _hoisted_129 = {
  key: 28,
  class: "right"
}
const _hoisted_130 = {
  key: 29,
  class: "right"
}
const _hoisted_131 = {
  key: 30,
  class: "right"
}
const _hoisted_132 = ["title"]

import { ref, computed } from 'vue';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { compareJobThenName } from '@/policies/jobTypeSort';
import { formatDurationHoursMinutes } from '@/composables/wage/useWageCalculator';
import {
  dbWageAmount,
  getHomeWageLedgerNetPay,
  getHomeWageLedgerAccountingGrossPay,
  sumHomeWageAccountingDisplayPayParts,
  getHomeWageCaregiverSlipPayDisplay,
  getHomeWageAdminSettingDisplayParts,
  calcHomeWageClientReportGrossPay,
  buildHomeWageClientReportRowFromDb,
  resolveHomeWageSevereDisplayAmount,
  resolveHomeWageDisplayRetirementAmount,
  isHomeWageLaborDayMonth,
  hasHomeWageStoredCtParts,
  readHomeWageStoredCtParts,
  sumHomeWageStoredCtPayParts,
  HOME_WAGE_NONTAX_TERM,
} from '@/policies';

interface HomeWageListRow {
  idx?: number;
  m_code?: string;
  bizGubun?: string;
  yearMonth?: string;
  payDate?: string;
  payCalcHourly?: number;
  name?: string;
  birth?: string;
  job?: string;
  basic?: number;
  weekend?: number;
  annual?: number;
  laborDay?: number;
  overtime?: number;
  overtimeNontax?: number;
  night?: number;
  nightNontax?: number;
  holiday?: number;
  holidayNontax?: number;
  senior?: number;
  sunim?: number;
  bosu?: number;
  severe?: number;
  lunch?: number;
  lunchDirector?: number;
  bonus?: number;
  car?: number;
  child?: number;
  welfare?: number;
  other?: number;
  wageTotal?: number;
  l_yeon?: number;
  l_gun?: number;
  l_jang?: number;
  l_go?: number;
  l_so?: number;
  l_ji?: number;
  l_jiwon?: number;
  l_bonin?: number;
  l_etc?: number;
  l_total?: number;
  c_yeon?: number;
  c_gun?: number;
  c_jang?: number;
  c_go?: number;
  c_sil?: number;
  c_san?: number;
  c_out?: number;
  c_total?: number;
  net?: number;
  grossPay?: number;
  nonTax?: number;
  l_save?: number;
  c_save?: number;
  profit?: number;
  svc?: string;
  cnt?: string;
  hour?: string;
  days?: string;
  memo?: string;
  overtimeHours?: number;
  nightHours?: number;
  holidayHours?: number;
  payOvertime?: string | boolean | null;
  payHoliday?: string | boolean | null;
  payNight?: string | boolean | null;
  productionNontax?: string | boolean | null;
}

interface Props {
  year: number;
  month: number;
  wageData: HomeWageListRow[];
  memberName?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWageReportExcel',
  props: {
    year: {},
    month: {},
    wageData: {},
    memberName: {}
  },
  emits: ["error"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

/**
 * 방문요양 임금대장 엑셀 다운로드 컴포넌트
 * - caion_wage_home_data (cwhd_*) 필드 기반
 */
const showModal = ref(false);
const isDownloading = ref(false);
const reportType = ref<'accounting' | 'client'>('accounting');

/** 급여대장 데이터 Row (API 응답 형태) */
const props = __props;

/** 귀속 연월 (YYYYMM) */
const reportYearMonth = computed(
  () => `${props.year}${String(props.month).padStart(2, '0')}`
);

/** 노동절수당 — 5월 급여에만 표시 */
const isLaborDayReportMonth = computed(() =>
  isHomeWageLaborDayMonth(reportYearMonth.value)
);

/** 5월 외·DB 레거시값 무시 */
const getDisplayLaborDay = (row: HomeWageListRow) => {
  if (!isLaborDayReportMonth.value) return 0;
  if (isClientReport()) {
    const ct = getStoredCt(row);
    return ct ? ct.laborDay : dbWageAmount(row.laborDay);
  }
  return getAdminParts(row).laborDay;
};

/** 센터장·일반임금대장 — slip */
const toClientReportRow = (row: HomeWageListRow) =>
  buildHomeWageClientReportRowFromDb(row as Record<string, unknown>);

const getStoredCt = (row: HomeWageListRow) => {
  const rec = row as Record<string, unknown>;
  if (!hasHomeWageStoredCtParts(rec)) return null;
  return readHomeWageStoredCtParts(rec, reportYearMonth.value);
};

const getClientSlipPayDisplay = (row: HomeWageListRow) =>
  getHomeWageCaregiverSlipPayDisplay(toClientReportRow(row));

const getClientAllowance = (
  row: HomeWageListRow,
  key: 'senior' | 'sunim' | 'bosu' | 'bonus' | 'car' | 'child' | 'welfare' | 'other'
) => {
  const ct = getStoredCt(row);
  if (ct) return ct[key];
  return dbWageAmount(row[key]);
};

const isClientReport = () => reportType.value === 'client';

/** 회계 — 관리자 시점 임금설정과 동일 칸 */
const getAdminParts = (row: HomeWageListRow) =>
  getHomeWageAdminSettingDisplayParts(
    row as Record<string, unknown>,
    reportYearMonth.value
  );

/**
 * 일반(센터장): slip — 중식→연차/기본급
 * 회계(관리자): 관리자 시점 임금설정과 동일
 */
const getDisplayBasic = (row: HomeWageListRow) => {
  if (isClientReport()) {
    const ct = getStoredCt(row);
    return ct ? ct.basic : getClientSlipPayDisplay(row).basic;
  }
  return getAdminParts(row).basic;
};

const getDisplayWeekend = (row: HomeWageListRow) => {
  if (isClientReport()) {
    const ct = getStoredCt(row);
    return ct ? ct.weekend : getClientSlipPayDisplay(row).weekend;
  }
  return getAdminParts(row).weekend;
};

const getDisplayAnnual = (row: HomeWageListRow) => {
  if (isClientReport()) {
    const ct = getStoredCt(row);
    return ct ? ct.annual : getClientSlipPayDisplay(row).annual;
  }
  return getAdminParts(row).annual;
};

const getDisplayHoliday = (row: HomeWageListRow) => {
  if (isClientReport()) {
    const ct = getStoredCt(row);
    return ct ? ct.holiday : getClientSlipPayDisplay(row).holiday;
  }
  return getAdminParts(row).holiday + getAdminParts(row).holidayNontax;
};

const getDisplayNight = (row: HomeWageListRow) => {
  if (isClientReport()) {
    const ct = getStoredCt(row);
    return ct ? ct.night : getClientSlipPayDisplay(row).night;
  }
  return getAdminParts(row).night + getAdminParts(row).nightNontax;
};

const getDisplayOvertimeTotal = (row: HomeWageListRow) => {
  if (isClientReport()) {
    const ct = getStoredCt(row);
    return ct ? ct.overtime : getClientSlipPayDisplay(row).overtime;
  }
  return getAdminParts(row).overtime + getAdminParts(row).overtimeNontax;
};

const getDisplaySevere = (row: HomeWageListRow) => {
  if (isClientReport()) {
    const ct = getStoredCt(row);
    return ct ? ct.severe : resolveHomeWageSevereDisplayAmount(toClientReportRow(row));
  }
  return getAdminParts(row).severe;
};

/** 고객용 — slip 중식 / 회계 — 자동중식 + 센터장 입력 중식 합산 */
const getDisplayLunch = (row: HomeWageListRow) => {
  if (isClientReport()) {
    const ct = getStoredCt(row);
    return ct ? ct.lunch : getClientSlipPayDisplay(row).lunch;
  }
  const p = getAdminParts(row);
  return p.lunchAuto + p.lunchDirector;
};

/** 회계 — 관리자 시점 과세/비과세 */
const getAccountingOvertimeTax = (row: HomeWageListRow) => getAdminParts(row).overtime;
const getAccountingOvertimeNontax = (row: HomeWageListRow) => getAdminParts(row).overtimeNontax;
const getAccountingNightTax = (row: HomeWageListRow) => getAdminParts(row).night;
const getAccountingNightNontax = (row: HomeWageListRow) => getAdminParts(row).nightNontax;
const getAccountingHolidayTax = (row: HomeWageListRow) => getAdminParts(row).holiday;
const getAccountingHolidayNontax = (row: HomeWageListRow) => getAdminParts(row).holidayNontax;
const getAccountingPremiumNontax = (row: HomeWageListRow) =>
  getAccountingOvertimeNontax(row) + getAccountingNightNontax(row) + getAccountingHolidayNontax(row);
const getAccountingPremiumTax = (row: HomeWageListRow) =>
  getAccountingOvertimeTax(row) + getAccountingNightTax(row) + getAccountingHolidayTax(row);

/** 퇴직금 — 실비변상 식대 차감 산식 (저장 c_out 구값 보정) */
const getReportRetirement = (row: HomeWageListRow) =>
  resolveHomeWageDisplayRetirementAmount(
    row as Record<string, unknown>,
    reportYearMonth.value
  );

/** 기관공제합계 — 보험 항목 + 표시용 퇴직금 */
const getReportCorpTotal = (row: HomeWageListRow) =>
  dbWageAmount(row.c_yeon)
  + dbWageAmount(row.c_gun)
  + dbWageAmount(row.c_jang)
  + dbWageAmount(row.c_go)
  + dbWageAmount(row.c_sil)
  + dbWageAmount(row.c_san)
  + getReportRetirement(row);

const getDisplayWageField = (row: HomeWageListRow, field: string): number => {
  switch (field) {
    case 'basic':
      return getDisplayBasic(row);
    case 'weekend':
      return getDisplayWeekend(row);
    case 'annual':
      return getDisplayAnnual(row);
    case 'laborDay':
      return getDisplayLaborDay(row);
    case 'overtime':
      return isClientReport() ? getDisplayOvertimeTotal(row) : getAccountingOvertimeTax(row);
    case 'overtimeNontax':
      return getAccountingOvertimeNontax(row);
    case 'night':
      return isClientReport() ? getDisplayNight(row) : getAccountingNightTax(row);
    case 'nightNontax':
      return getAccountingNightNontax(row);
    case 'holiday':
      return isClientReport() ? getDisplayHoliday(row) : getAccountingHolidayTax(row);
    case 'holidayNontax':
      return getAccountingHolidayNontax(row);
    case 'premiumNontax':
      return getAccountingPremiumNontax(row);
    case 'premiumTax':
      return getAccountingPremiumTax(row);
    case '_overtime_total':
      return getDisplayOvertimeTotal(row);
    case '_night_total':
      return getDisplayNight(row);
    case '_holiday_total':
      return getDisplayHoliday(row);
    case 'severe':
      return getDisplaySevere(row);
    case 'lunch':
      return getDisplayLunch(row);
    case 'sunim':
      return isClientReport()
        ? getClientAllowance(row, 'sunim')
        : getAdminParts(row).sunim;
    case 'c_out':
      return getReportRetirement(row);
    case 'c_total':
      return getReportCorpTotal(row);
    default:
      if (isClientReport()) {
        const ct = getStoredCt(row);
        if (ct && field in ct) {
          return ct[field as keyof typeof ct] as number;
        }
      }
      return dbWageAmount((row as Record<string, unknown>)[field] as number);
  }
};

const emit = __emit;

// 만나이 계산
const calculateAge = (birthDateStr: string | undefined, year: number, month: number) => {
  if (!birthDateStr) return '';
  const birthDate = new Date(birthDateStr);
  const baseDate = new Date(year, month - 1, 1);
  let age = baseDate.getFullYear() - birthDate.getFullYear();
  if (baseDate.getMonth() < birthDate.getMonth() || 
      (baseDate.getMonth() === birthDate.getMonth() && baseDate.getDate() < birthDate.getDate())) {
    age--;
  }
  return age > 0 ? `만${age}세` : '';
};

const formatReportFileName = (
  memberName: string | undefined,
  year: number,
  month: number,
  kind: 'client' | 'accounting' = 'client'
) => {
  const facility = (memberName || '시설').trim().replace(/[\\/:*?"<>|]/g, '_') || '시설';
  const mm = String(month).padStart(2, '0');
  if (kind === 'accounting') {
    return `${facility}_${year}년${mm}월_회계처리용_임금대장.xlsx`;
  }
  return `${facility}_${year}년${mm}월_임금대장.xlsx`;
};

// 숫자 포맷팅
const formatNumber = (num: number | undefined | null) => {
  const n = Number(num) || 0;
  return n.toLocaleString();
};

const formatWorkHoursCell = (hour?: string | number | null) =>
  formatDurationHoursMinutes(hour) || String(hour ?? '') || '0';

/** 회계 — 관리자 시점 합계 / 일반 — 센터장 slip 합계 */
const getRowGrossPay = (row: HomeWageListRow) =>
  getHomeWageLedgerAccountingGrossPay(
    row as unknown as Record<string, unknown>,
    reportYearMonth.value
  );

const getClientRowGrossPay = (row: HomeWageListRow) => {
  const ct = getStoredCt(row);
  if (ct) return sumHomeWageStoredCtPayParts(ct);
  return calcHomeWageClientReportGrossPay(toClientReportRow(row), reportYearMonth.value);
};

const getReportRowGrossPay = (row: HomeWageListRow) =>
  isClientReport() ? getClientRowGrossPay(row) : getRowGrossPay(row);

const isAmountClose = (a: number, b: number) => Math.abs(a - b) <= 1;

/** 엑셀 합계 키 — 근로자/기관 국민연금처럼 라벨이 같아도 컬럼을 구분 */
const excelColTotalKey = (col: { field?: string | null; name: string }) =>
  col.field || col.name;

/** 시트 맨 위 제목 */
const wageLedgerTitle = () => {
  const facility = (props.memberName || '').trim();
  const period = `${props.year}년 ${props.month}월 임금대장`;
  return facility ? `${facility} ${period}` : period;
};

const addWageLedgerTitleRow = (worksheet: ExcelJS.Worksheet, title: string, colCount: number) => {
  const titleRow = worksheet.addRow([title]);
  titleRow.height = 32;
  const lastCol = Math.max(colCount, 1);
  for (let i = 1; i <= lastCol; i++) {
    const cell = titleRow.getCell(i);
    cell.font = { bold: true, size: 16, color: { argb: 'FF1e3a5f' } };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
  }
  if (lastCol > 1) {
    worksheet.mergeCells(1, 1, 1, lastCol);
  }
};

/** 미리보기 항목 합 — 해당 시점 표시 칸 기준 (항목합=합계) */
const sumPreviewWageColumns = (row: HomeWageListRow) => {
  if (!isClientReport()) {
    // 회계: 정책 단일 소스 (표시 칸 합 = 임금합계)
    return sumHomeWageAccountingDisplayPayParts(
      row as unknown as Record<string, unknown>,
      reportYearMonth.value
    );
  }
  const ct = getStoredCt(row);
  return (
    getDisplayBasic(row) +
    getDisplayWeekend(row) +
    getDisplayAnnual(row) +
    getDisplayLaborDay(row) +
    getDisplayOvertimeTotal(row) +
    getDisplayNight(row) +
    getDisplayHoliday(row) +
    (ct ? ct.senior : dbWageAmount(row.senior)) +
    (ct ? ct.sunim : dbWageAmount(row.sunim)) +
    (ct ? ct.bosu : dbWageAmount(row.bosu)) +
    getDisplaySevere(row) +
    (ct ? ct.bonus : dbWageAmount(row.bonus)) +
    getDisplayLunch(row) +
    (ct ? ct.car : dbWageAmount(row.car)) +
    (ct ? ct.child : dbWageAmount(row.child)) +
    (ct ? ct.welfare : dbWageAmount(row.welfare)) +
    (ct ? ct.other : dbWageAmount(row.other))
  );
};

/** 미리보기 임금합계 불일치 — 화면 항목 합 ≠ 임금합계 칸 */
const rowWageMismatch = (row: HomeWageListRow) => {
  const displayed = getReportRowGrossPay(row);
  const parts = sumPreviewWageColumns(row);
  if (parts === 0 && displayed === 0) return false;
  return !isAmountClose(parts, displayed);
};

const sumLaborDeductParts = (row: HomeWageListRow) =>
  dbWageAmount(row.l_yeon) +
  dbWageAmount(row.l_gun) +
  dbWageAmount(row.l_jang) +
  dbWageAmount(row.l_go) +
  dbWageAmount(row.l_so) +
  dbWageAmount(row.l_ji) +
  dbWageAmount(row.l_jiwon) +
  dbWageAmount(row.l_bonin) +
  dbWageAmount(row.l_etc);

const sumCorpDeductParts = (row: HomeWageListRow) =>
  dbWageAmount(row.c_yeon) +
  dbWageAmount(row.c_gun) +
  dbWageAmount(row.c_jang) +
  dbWageAmount(row.c_go) +
  dbWageAmount(row.c_sil) +
  dbWageAmount(row.c_san) +
  getReportRetirement(row);

const rowLaborMismatch = (row: HomeWageListRow) =>
  !isAmountClose(sumLaborDeductParts(row), dbWageAmount(row.l_total));

const rowCorpMismatch = (row: HomeWageListRow) =>
  !isAmountClose(sumCorpDeductParts(row), getReportCorpTotal(row));

const footerMismatch = computed(() => {
  const t = totals.value;
  const anyRowWage = sortedData.value.some((r) => rowWageMismatch(r));
  const anyRowLabor = sortedData.value.some((r) => rowLaborMismatch(r));
  const anyRowCorp = sortedData.value.some((r) => rowCorpMismatch(r));
  const previewPartsSum = sortedData.value.reduce(
    (s, r) => s + sumPreviewWageColumns(r),
    0
  );
  return {
    wage: anyRowWage || !isAmountClose(previewPartsSum, t.grossPay),
    labor: anyRowLabor,
    corp: anyRowCorp,
  };
});

/** 실수령액 = 표시 지급금액 − 근로자공제 (DB cwhd_net 레거시 보정) */
const getRowNetPay = (row: HomeWageListRow) =>
  getHomeWageLedgerNetPay(row as Record<string, unknown>, {
    grossPay: getReportRowGrossPay(row),
    yearMonth: reportYearMonth.value,
    reportType: reportType.value,
  });

const hasDisplayLunch = () =>
  (props.wageData?.some((row) => getDisplayLunch(row) > 0) ?? false);

const reportModalTitle = computed(() => {
  const prefix = reportType.value === 'accounting' ? '회계처리용 ' : '';
  return `${props.memberName || '시설'} ${prefix}임금대장 미리보기 (${props.year}년 ${props.month}월)`;
});

// 정렬된 데이터
const sortedData = computed(() => {
  if (!props.wageData) return [];
  return [...props.wageData].sort((a, b) =>
    compareJobThenName(a.job, a.name, b.job, b.name)
  );
});

// 합계 계산
const totals = computed(() => {
  const t = {
    basic: 0, weekend: 0, annual: 0, laborDay: 0,
    overtime: 0, overtimeNontax: 0, night: 0, nightNontax: 0, holiday: 0, holidayNontax: 0,
    premiumTax: 0, premiumNontax: 0,
    overtimeTotal: 0, nightTotal: 0, holidayTotal: 0,
    senior: 0, sunim: 0, bosu: 0, severe: 0,
    bonus: 0, lunch: 0, car: 0, child: 0, welfare: 0, other: 0,
    wageTotal: 0, nonTax: 0, grossPay: 0,
    lYeon: 0, lGun: 0, lJang: 0, lGo: 0, lSo: 0, lJi: 0, lJiwon: 0, lBonin: 0, lEtc: 0, lTotal: 0,
    cYeon: 0, cGun: 0, cJang: 0, cGo: 0, cSil: 0, cSan: 0, cOut: 0, cTotal: 0,
    netPay: 0
  };
  sortedData.value.forEach(row => {
    t.basic += getDisplayBasic(row);
    t.weekend += getDisplayWeekend(row);
    t.annual += getDisplayAnnual(row);
    t.laborDay += getDisplayLaborDay(row);
    t.overtime += getAccountingOvertimeTax(row);
    t.overtimeNontax += getAccountingOvertimeNontax(row);
    t.night += getAccountingNightTax(row);
    t.nightNontax += getAccountingNightNontax(row);
    t.holiday += getAccountingHolidayTax(row);
    t.holidayNontax += getAccountingHolidayNontax(row);
    t.premiumTax += getAccountingPremiumTax(row);
    t.premiumNontax += getAccountingPremiumNontax(row);
    t.overtimeTotal += getDisplayOvertimeTotal(row);
    t.nightTotal += getDisplayNight(row);
    t.holidayTotal += getDisplayHoliday(row);
    t.senior += isClientReport() ? getClientAllowance(row, 'senior') : getAdminParts(row).senior;
    t.sunim += isClientReport() ? getClientAllowance(row, 'sunim') : getAdminParts(row).sunim;
    t.bosu += isClientReport() ? getClientAllowance(row, 'bosu') : getAdminParts(row).bosu;
    t.severe += getDisplaySevere(row);
    t.bonus += isClientReport() ? getClientAllowance(row, 'bonus') : getAdminParts(row).bonus;
    t.lunch += getDisplayLunch(row);
    t.car += isClientReport() ? getClientAllowance(row, 'car') : getAdminParts(row).car;
    t.child += isClientReport() ? getClientAllowance(row, 'child') : getAdminParts(row).child;
    t.welfare += isClientReport() ? getClientAllowance(row, 'welfare') : getAdminParts(row).welfare;
    t.other += isClientReport() ? getClientAllowance(row, 'other') : getAdminParts(row).other;
    t.wageTotal += dbWageAmount(row.wageTotal);
    t.nonTax += dbWageAmount(row.nonTax);
    t.grossPay += getReportRowGrossPay(row);
    t.lYeon += dbWageAmount(row.l_yeon);
    t.lGun += dbWageAmount(row.l_gun);
    t.lJang += dbWageAmount(row.l_jang);
    t.lGo += dbWageAmount(row.l_go);
    t.lSo += dbWageAmount(row.l_so);
    t.lJi += dbWageAmount(row.l_ji);
    t.lJiwon += dbWageAmount(row.l_jiwon);
    t.lBonin += dbWageAmount(row.l_bonin);
    t.lEtc += dbWageAmount(row.l_etc);
    t.lTotal += dbWageAmount(row.l_total);
    t.cYeon += dbWageAmount(row.c_yeon);
    t.cGun += dbWageAmount(row.c_gun);
    t.cJang += dbWageAmount(row.c_jang);
    t.cGo += dbWageAmount(row.c_go);
    t.cSil += dbWageAmount(row.c_sil);
    t.cSan += dbWageAmount(row.c_san);
    t.cOut += getReportRetirement(row);
    t.cTotal += getReportCorpTotal(row);
    t.netPay += getRowNetPay(row);
  });
  return t;
});

// 0원이 아닌 값이 있는지 확인
const hasNonZero = (field: keyof HomeWageListRow): boolean => {
  if (!props.wageData) return false;
  return props.wageData.some(row => (row[field] as number) > 0);
};

// 컬럼 표시 여부 — 표시 금액(slip) 기준
const showColumns = computed(() => ({
  weekend: props.wageData?.some((row) => getDisplayWeekend(row) > 0) ?? false,
  annual: props.wageData?.some((row) => getDisplayAnnual(row) > 0) ?? false,
  laborDay: isLaborDayReportMonth.value && props.wageData.some((row) => getDisplayLaborDay(row) > 0),
  premiumTax: props.wageData?.some((row) => getAccountingPremiumTax(row) > 0) ?? false,
  premiumNontax: props.wageData?.some((row) => getAccountingPremiumNontax(row) > 0) ?? false,
  senior: hasNonZero('senior'),
  sunim: props.wageData?.some((row) =>
    (isClientReport() ? getClientAllowance(row, 'sunim') : getAdminParts(row).sunim) > 0
  ) ?? false,
  bosu: hasNonZero('bosu'),
  severe: props.wageData?.some((row) => getDisplaySevere(row) > 0) ?? false,
  bonus: hasNonZero('bonus'),
  lunch: hasDisplayLunch(),
  car: hasNonZero('car'),
  child: hasNonZero('child'),
  welfare: hasNonZero('welfare'),
  other: hasNonZero('other'),
  // 근로자공제
  lYeon: hasNonZero('l_yeon'),
  lGun: hasNonZero('l_gun'),
  lJang: hasNonZero('l_jang'),
  lGo: hasNonZero('l_go'),
  lSo: hasNonZero('l_so'),
  lJi: hasNonZero('l_ji'),
  lJiwon: hasNonZero('l_jiwon'),
  lBonin: hasNonZero('l_bonin'),
  lEtc: hasNonZero('l_etc'),
  // 기관공제
  cYeon: hasNonZero('c_yeon'),
  cGun: hasNonZero('c_gun'),
  cJang: hasNonZero('c_jang'),
  cGo: hasNonZero('c_go'),
  cSil: hasNonZero('c_sil'),
  cSan: hasNonZero('c_san'),
  cOut: props.wageData?.some((row) => getReportRetirement(row) > 0) ?? false,
}));

const showClientColumns = computed(() => ({
  overtimeTotal: props.wageData?.some((r) => getDisplayOvertimeTotal(r) > 0) ?? false,
  nightTotal: props.wageData?.some((r) => getDisplayNight(r) > 0) ?? false,
  holidayTotal: props.wageData?.some((r) => getDisplayHoliday(r) > 0) ?? false,
}));

/** 미리보기 합계행 — 표시 금액(slip) 기준 */
const displayBasicTotal = computed(() => totals.value.basic);
const displayAnnualTotal = computed(() => totals.value.annual);
const displayHolidayTotal = computed(() => totals.value.holidayTotal);
const displayNightTotal = computed(() => totals.value.nightTotal);
const displayOvertimeTotal = computed(() => totals.value.overtimeTotal);

// 동적 colspan 계산
const wageColspan = computed(() => {
  let count = 2; // 기본급, 임금합계 (필수)
  const s = showColumns.value;
  const sc = showClientColumns.value;

  if (reportType.value === 'client') {
    if (sc.overtimeTotal) count++;
    if (sc.nightTotal) count++;
    if (sc.holidayTotal) count++;
  } else {
    if (s.premiumTax) count++;
    if (s.premiumNontax) count++;
  }
  if (s.weekend) count++;
  if (s.annual) count++;
  if (s.laborDay) count++;
  if (s.senior) count++;
  if (s.sunim) count++;
  if (s.bosu) count++;
  if (s.severe) count++;
  if (s.bonus) count++;
  if (s.lunch) count++;
  if (s.car) count++;
  if (s.child) count++;
  if (s.welfare) count++;
  if (s.other) count++;
  return count;
});

const empDeductColspan = computed(() => {
  let count = 1; // 공제합계 (필수)
  const s = showColumns.value;
  if (s.lYeon) count++;
  if (s.lGun) count++;
  if (s.lJang) count++;
  if (s.lGo) count++;
  if (s.lSo) count++;
  if (s.lJi) count++;
  if (s.lJiwon) count++;
  if (s.lBonin) count++;
  if (s.lEtc) count++;
  return count;
});

const corpDeductColspan = computed(() => {
  let count = 1; // 기관합계 (필수)
  const s = showColumns.value;
  if (s.cYeon) count++;
  if (s.cGun) count++;
  if (s.cJang) count++;
  if (s.cGo) count++;
  if (s.cSil) count++;
  if (s.cSan) count++;
  if (s.cOut) count++;
  return count;
});

// 미리보기 열기
const openPreview = (type: 'accounting' | 'client' = 'accounting') => {
  reportType.value = type;
  showModal.value = true;
};

// 미리보기 닫기
const closePreview = () => {
  showModal.value = false;
};

// 다운로드
const handleDownload = () => {
  if (reportType.value === 'client') {
    downloadClientReport();
  } else {
    downloadPayrollReport();
  }
};

// 임금대장 엑셀 다운로드
const downloadPayrollReport = async () => {
  if (!props.wageData || props.wageData.length === 0) {
    emit('error', '다운로드할 데이터가 없습니다.');
    return;
  }

  isDownloading.value = true;
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('임금대장');

    type ColDef = { group: string; name: string; field: string | null; required?: boolean };
    const allColumns: ColDef[] = [
      // 기본정보 (필수)
      { group: 'basic', name: '순번', field: null, required: true },
      { group: 'basic', name: '성명', field: null, required: true },
      { group: 'basic', name: '생년월일', field: null, required: true },
      { group: 'basic', name: '직종', field: null, required: true },
      // 근로정보 (필수)
      { group: 'work', name: '시급', field: 'payCalcHourly', required: true },
      { group: 'work', name: '일수', field: 'days', required: true },
      { group: 'work', name: '시간', field: 'hour', required: true },
      // 임금구성
      { group: 'wage', name: '기본급', field: 'basic', required: true },
      { group: 'wage', name: '주휴수당', field: 'weekend' },
      { group: 'wage', name: '연차수당', field: 'annual' },
      { group: 'wage', name: '노동절수당(비과세)', field: 'laborDay' },
      { group: 'wage', name: '연야휴과세', field: 'premiumTax' },
      { group: 'wage', name: '연야휴비과세', field: 'premiumNontax' },
      { group: 'wage', name: '장기근속', field: 'senior' },
      { group: 'wage', name: '선임수당', field: 'sunim' },
      { group: 'wage', name: '보수교육', field: 'bosu' },
      { group: 'wage', name: '중증가산', field: 'severe' },
      { group: 'wage', name: '상여금', field: 'bonus' },
      { group: 'wage', name: HOME_WAGE_NONTAX_TERM.lunch, field: 'lunch' },
      { group: 'wage', name: HOME_WAGE_NONTAX_TERM.car, field: 'car' },
      { group: 'wage', name: HOME_WAGE_NONTAX_TERM.child, field: 'child' },
      { group: 'wage', name: '처우개선', field: 'welfare' },
      { group: 'wage', name: '기타수당', field: 'other' },
      { group: 'wage', name: '임금합계', field: null, required: true },
      // 근로자공제
      { group: 'empDeduct', name: '국민연금', field: 'l_yeon' },
      { group: 'empDeduct', name: '건강보험', field: 'l_gun' },
      { group: 'empDeduct', name: '장기요양', field: 'l_jang' },
      { group: 'empDeduct', name: '고용보험', field: 'l_go' },
      { group: 'empDeduct', name: '소득세', field: 'l_so' },
      { group: 'empDeduct', name: '지방세', field: 'l_ji' },
      { group: 'empDeduct', name: '지원공제', field: 'l_jiwon' },
      { group: 'empDeduct', name: '본인부담금', field: 'l_bonin' },
      { group: 'empDeduct', name: '기타공제', field: 'l_etc' },
      { group: 'empDeduct', name: '근로자공제합계', field: 'l_total', required: true },
      { group: 'net', name: '실수령액', field: null, required: true },
      // 기관공제
      { group: 'corpDeduct', name: '국민연금', field: 'c_yeon' },
      { group: 'corpDeduct', name: '건강보험', field: 'c_gun' },
      { group: 'corpDeduct', name: '장기요양', field: 'c_jang' },
      { group: 'corpDeduct', name: '고용보험', field: 'c_go' },
      { group: 'corpDeduct', name: '실업급여', field: 'c_sil' },
      { group: 'corpDeduct', name: '산재보험', field: 'c_san' },
      { group: 'corpDeduct', name: '퇴직금', field: 'c_out' },
      { group: 'corpDeduct', name: '기관공제합계', field: 'c_total', required: true },
      { group: 'remark', name: '비고', field: null, required: true }
    ];

    const laborDayMonth = isHomeWageLaborDayMonth(
      `${props.year}${String(props.month).padStart(2, '0')}`
    );

    // 0이 아닌 값이 있는 컬럼만 포함 (표시 금액·노동절 5월만)
    const hasNonZeroValue = (field: string | null): boolean => {
      if (!field) return true;
      if (field === 'laborDay' && !laborDayMonth) return false;
      return props.wageData.some((row) => getDisplayWageField(row, field) > 0);
    };

    const activeColumns = allColumns.filter(col => col.required || hasNonZeroValue(col.field));

    // 2단 헤더 생성
    const header2Columns = activeColumns.map(col => col.name);

    // 그룹별 시작/끝 인덱스 계산
    const getGroupRange = (groupName: string) => {
      const cols = activeColumns.map((c, i) => ({ ...c, idx: i + 1 })).filter(c => c.group === groupName);
      if (cols.length === 0) return null;
      return { start: cols[0].idx, end: cols[cols.length - 1].idx };
    };

    const basicRange = getGroupRange('basic');
    const workRange = getGroupRange('work');
    const wageRange = getGroupRange('wage');
    const empDeductRange = getGroupRange('empDeduct');
    const corpDeductRange = getGroupRange('corpDeduct');
    const netRange = getGroupRange('net');
    const remarkRange = getGroupRange('remark');

    addWageLedgerTitleRow(worksheet, wageLedgerTitle(), header2Columns.length);

    // 1단 헤더 행 추가 (제목행이 1행)
    const header1Row = worksheet.addRow([]);
    if (basicRange) header1Row.getCell(basicRange.start).value = '기본정보';
    if (workRange) header1Row.getCell(workRange.start).value = '근로정보';
    if (wageRange) header1Row.getCell(wageRange.start).value = '임금구성';
    if (empDeductRange) header1Row.getCell(empDeductRange.start).value = '근로자공제';
    if (corpDeductRange) header1Row.getCell(corpDeductRange.start).value = '기관공제';
    if (netRange) header1Row.getCell(netRange.start).value = '수령';
    if (remarkRange) header1Row.getCell(remarkRange.start).value = '비고';

    // 1단 헤더 병합
    if (basicRange && basicRange.end > basicRange.start) worksheet.mergeCells(2, basicRange.start, 2, basicRange.end);
    if (workRange && workRange.end > workRange.start) worksheet.mergeCells(2, workRange.start, 2, workRange.end);
    if (wageRange && wageRange.end > wageRange.start) worksheet.mergeCells(2, wageRange.start, 2, wageRange.end);
    if (empDeductRange && empDeductRange.end > empDeductRange.start) worksheet.mergeCells(2, empDeductRange.start, 2, empDeductRange.end);
    if (corpDeductRange && corpDeductRange.end > corpDeductRange.start) worksheet.mergeCells(2, corpDeductRange.start, 2, corpDeductRange.end);

    // 1단 헤더 스타일
    for (let i = 1; i <= header2Columns.length; i++) {
      const cell = header1Row.getCell(i);
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1e3a5f' } };
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    }

    // 2단 헤더 행 추가
    const header2Row = worksheet.addRow(header2Columns);
    header2Row.eachCell((cell, colNumber) => {
      let bgColor = 'FFD9E1F2';
      if (wageRange && colNumber >= wageRange.start && colNumber <= wageRange.end) bgColor = 'FFE2EFDA';
      if (empDeductRange && colNumber >= empDeductRange.start && colNumber <= empDeductRange.end) bgColor = 'FFFCE4D6';
      if (corpDeductRange && colNumber >= corpDeductRange.start && colNumber <= corpDeductRange.end) bgColor = 'FFFFF2CC';
      
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bgColor } };
      cell.font = { bold: true, size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // 열 너비 설정
    worksheet.getColumn(1).width = 6;
    worksheet.getColumn(2).width = 10;
    worksheet.getColumn(3).width = 12;
    worksheet.getColumn(4).width = 12;
    for (let i = 5; i <= header2Columns.length; i++) {
      const colName = header2Columns[i - 1];
      if (colName.includes('합계') || colName === '실수령액' || colName === '연야휴과세' || colName === '연야휴비과세') worksheet.getColumn(i).width = 13;
      else if (colName === '비고') worksheet.getColumn(i).width = 10;
      else if (colName === '기본급') worksheet.getColumn(i).width = 12;
      else if (colName.includes('중식비')) worksheet.getColumn(i).width = 14;
      else worksheet.getColumn(i).width = 10;
    }

    // 합계 변수
    const totals: Record<string, number> = {};
    activeColumns.forEach(col => { 
      if (col.field || col.name === '실수령액' || col.name === '임금합계') totals[excelColTotalKey(col)] = 0; 
    });

    // 데이터 행 추가
    sortedData.value.forEach((row, index) => {
      const grossPay = getReportRowGrossPay(row);
      const netPay = getRowNetPay(row);
      const remarkText = calculateAge(row.birth, props.year, props.month);

      const rowData = activeColumns.map((col) => {
        if (col.name === '순번') return index + 1;
        if (col.name === '성명') return row.name || '';
        if (col.name === '생년월일') return row.birth ? row.birth.substring(0, 10) : '';
        if (col.name === '직종') return row.job || '';
        if (col.name === '임금합계') return grossPay;
        if (col.name === '실수령액') return netPay;
        if (col.name === '비고') return remarkText;
        if (col.field === 'hour') return formatWorkHoursCell(row.hour) || '0';
        if (col.field) return getDisplayWageField(row, col.field);
        return '';
      });

      const dataRow = worksheet.addRow(rowData);
      const basicEnd = basicRange?.end || 4;
      const remarkStart = remarkRange?.start || activeColumns.length;
      
      dataRow.eachCell((cell, colNumber) => {
        const col = activeColumns[colNumber - 1];
        cell.alignment = { horizontal: colNumber <= basicEnd ? 'center' : 'right', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        if (colNumber > basicEnd && colNumber < remarkStart && col?.field !== 'hour') {
          cell.numFmt = '#,##0';
        }
        // 합계 누적
        if (col?.field && col.field !== 'hour') {
          const key = excelColTotalKey(col);
          totals[key] = (totals[key] || 0) + getDisplayWageField(row, col.field);
        }
        if (col?.name === '임금합계') totals['임금합계'] = (totals['임금합계'] || 0) + grossPay;
        if (col?.name === '실수령액') totals['실수령액'] = (totals['실수령액'] || 0) + netPay;
      });
    });

    // 합계 행
    const totalRowData = activeColumns.map((col) => {
      if (col.name === '순번') return '';
      if (col.name === '성명') return '합계';
      if (col.name === '생년월일' || col.name === '직종' || col.name === '비고') return '';
      return totals[excelColTotalKey(col)] || 0;
    });

    const totalRow = worksheet.addRow(totalRowData);
    const basicEnd = basicRange?.end || 4;
    const remarkStart = remarkRange?.start || activeColumns.length;
    totalRow.eachCell((cell, colNumber) => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF2CC' } };
      cell.font = { bold: true, size: 10 };
      cell.alignment = { horizontal: colNumber <= basicEnd ? 'center' : 'right', vertical: 'middle' };
      cell.border = { top: { style: 'medium' }, left: { style: 'thin' }, bottom: { style: 'medium' }, right: { style: 'thin' } };
      if (colNumber > basicEnd && colNumber < remarkStart) {
        cell.numFmt = '#,##0';
      }
    });

    // 파일 다운로드
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = formatReportFileName(props.memberName, props.year, props.month, 'accounting');
    saveAs(blob, fileName);
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : '알 수 없는 오류';
    console.error('엑셀 다운로드 오류:', error);
    emit('error', `임금대장 다운로드 중 오류가 발생했습니다: ${message}`);
  } finally {
    isDownloading.value = false;
  }
};

/** 임금대장(합산) 엑셀 다운로드 — 과세+비과세 합산 */
const downloadClientReport = async () => {
  if (!props.wageData || props.wageData.length === 0) {
    emit('error', '다운로드할 데이터가 없습니다.');
    return;
  }

  isDownloading.value = true;
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('임금대장');

    type ColDef = { group: string; name: string; field: string | null; required?: boolean };
    const allColumns: ColDef[] = [
      { group: 'basic', name: '순번', field: null, required: true },
      { group: 'basic', name: '성명', field: null, required: true },
      { group: 'basic', name: '생년월일', field: null, required: true },
      { group: 'basic', name: '직종', field: null, required: true },
      { group: 'work', name: '시급', field: 'payCalcHourly', required: true },
      { group: 'work', name: '일수', field: 'days', required: true },
      { group: 'work', name: '시간', field: 'hour', required: true },
      { group: 'wage', name: '기본급', field: 'basic', required: true },
      { group: 'wage', name: '주휴수당', field: 'weekend' },
      { group: 'wage', name: '연차수당', field: 'annual' },
      { group: 'wage', name: '노동절수당(비과세)', field: 'laborDay' },
      { group: 'wage', name: '연장수당', field: '_overtime_total' },
      { group: 'wage', name: '야간수당', field: '_night_total' },
      { group: 'wage', name: '휴일수당', field: '_holiday_total' },
      { group: 'wage', name: '장기근속', field: 'senior' },
      { group: 'wage', name: '보수교육', field: 'bosu' },
      { group: 'wage', name: '중증가산', field: 'severe' },
      { group: 'wage', name: '상여금', field: 'bonus' },
      { group: 'wage', name: HOME_WAGE_NONTAX_TERM.lunch, field: 'lunch' },
      { group: 'wage', name: HOME_WAGE_NONTAX_TERM.car, field: 'car' },
      { group: 'wage', name: HOME_WAGE_NONTAX_TERM.child, field: 'child' },
      { group: 'wage', name: '처우개선', field: 'welfare' },
      { group: 'wage', name: '기타수당', field: 'other' },
      { group: 'wage', name: '임금합계', field: null, required: true },
      { group: 'empDeduct', name: '국민연금', field: 'l_yeon' },
      { group: 'empDeduct', name: '건강보험', field: 'l_gun' },
      { group: 'empDeduct', name: '장기요양', field: 'l_jang' },
      { group: 'empDeduct', name: '고용보험', field: 'l_go' },
      { group: 'empDeduct', name: '소득세', field: 'l_so' },
      { group: 'empDeduct', name: '지방세', field: 'l_ji' },
      { group: 'empDeduct', name: '지원공제', field: 'l_jiwon' },
      { group: 'empDeduct', name: '본인부담금', field: 'l_bonin' },
      { group: 'empDeduct', name: '기타공제', field: 'l_etc' },
      { group: 'empDeduct', name: '근로자공제합계', field: 'l_total', required: true },
      { group: 'net', name: '실수령액', field: null, required: true },
      { group: 'corpDeduct', name: '국민연금', field: 'c_yeon' },
      { group: 'corpDeduct', name: '건강보험', field: 'c_gun' },
      { group: 'corpDeduct', name: '장기요양', field: 'c_jang' },
      { group: 'corpDeduct', name: '고용보험', field: 'c_go' },
      { group: 'corpDeduct', name: '실업급여', field: 'c_sil' },
      { group: 'corpDeduct', name: '산재보험', field: 'c_san' },
      { group: 'corpDeduct', name: '퇴직금', field: 'c_out' },
      { group: 'corpDeduct', name: '기관공제합계', field: 'c_total', required: true },
      { group: 'remark', name: '비고', field: null, required: true },
    ];

    const getFieldValue = (row: HomeWageListRow, field: string | null): number => {
      if (!field) return 0;
      return getDisplayWageField(row, field);
    };

    const laborDayMonthClient = isHomeWageLaborDayMonth(
      `${props.year}${String(props.month).padStart(2, '0')}`
    );

    const hasNonZeroValue = (field: string | null): boolean => {
      if (!field) return true;
      if (field === 'laborDay') {
        if (!laborDayMonthClient) return false;
        return props.wageData.some((row) => getDisplayLaborDay(row) > 0);
      }
      if (field === 'annual') {
        return props.wageData.some((row) => getFieldValue(row, 'annual') > 0);
      }
      if (field === 'basic') return true;
      return props.wageData.some((row) => getFieldValue(row, field) > 0);
    };

    const activeColumns = allColumns.filter((col) => col.required || hasNonZeroValue(col.field));
    const header2Columns = activeColumns.map((col) => col.name);

    const getGroupRange = (groupName: string) => {
      const cols = activeColumns.map((c, i) => ({ ...c, idx: i + 1 })).filter((c) => c.group === groupName);
      if (cols.length === 0) return null;
      return { start: cols[0].idx, end: cols[cols.length - 1].idx };
    };

    const basicRange = getGroupRange('basic');
    const workRange = getGroupRange('work');
    const wageRange = getGroupRange('wage');
    const empDeductRange = getGroupRange('empDeduct');
    const corpDeductRange = getGroupRange('corpDeduct');
    const netRange = getGroupRange('net');
    const remarkRange = getGroupRange('remark');

    addWageLedgerTitleRow(worksheet, wageLedgerTitle(), header2Columns.length);

    const header1Row = worksheet.addRow([]);
    if (basicRange) header1Row.getCell(basicRange.start).value = '기본정보';
    if (workRange) header1Row.getCell(workRange.start).value = '근로정보';
    if (wageRange) header1Row.getCell(wageRange.start).value = '임금구성';
    if (empDeductRange) header1Row.getCell(empDeductRange.start).value = '근로자공제';
    if (corpDeductRange) header1Row.getCell(corpDeductRange.start).value = '기관공제';
    if (netRange) header1Row.getCell(netRange.start).value = '수령';
    if (remarkRange) header1Row.getCell(remarkRange.start).value = '비고';

    if (basicRange && basicRange.end > basicRange.start) {
      worksheet.mergeCells(2, basicRange.start, 2, basicRange.end);
    }
    if (workRange && workRange.end > workRange.start) {
      worksheet.mergeCells(2, workRange.start, 2, workRange.end);
    }
    if (wageRange && wageRange.end > wageRange.start) {
      worksheet.mergeCells(2, wageRange.start, 2, wageRange.end);
    }
    if (empDeductRange && empDeductRange.end > empDeductRange.start) {
      worksheet.mergeCells(2, empDeductRange.start, 2, empDeductRange.end);
    }
    if (corpDeductRange && corpDeductRange.end > corpDeductRange.start) {
      worksheet.mergeCells(2, corpDeductRange.start, 2, corpDeductRange.end);
    }

    for (let i = 1; i <= header2Columns.length; i++) {
      const cell = header1Row.getCell(i);
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1e3a5f' } };
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }

    const header2Row = worksheet.addRow(header2Columns);
    header2Row.eachCell((cell, colNumber) => {
      let bgColor = 'FFD9E1F2';
      if (wageRange && colNumber >= wageRange.start && colNumber <= wageRange.end) bgColor = 'FFE2EFDA';
      if (empDeductRange && colNumber >= empDeductRange.start && colNumber <= empDeductRange.end) {
        bgColor = 'FFFCE4D6';
      }
      if (corpDeductRange && colNumber >= corpDeductRange.start && colNumber <= corpDeductRange.end) {
        bgColor = 'FFFFF2CC';
      }

      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bgColor } };
      cell.font = { bold: true, size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    worksheet.getColumn(1).width = 6;
    worksheet.getColumn(2).width = 10;
    worksheet.getColumn(3).width = 12;
    worksheet.getColumn(4).width = 12;
    for (let i = 5; i <= header2Columns.length; i++) {
      const colName = header2Columns[i - 1];
      if (colName.includes('합계') || colName === '실수령액' || colName === '연야휴과세' || colName === '연야휴비과세') worksheet.getColumn(i).width = 13;
      else if (colName === '비고') worksheet.getColumn(i).width = 10;
      else if (colName === '기본급') worksheet.getColumn(i).width = 12;
      else if (colName.includes('중식비')) worksheet.getColumn(i).width = 14;
      else worksheet.getColumn(i).width = 10;
    }

    const totalsMap: Record<string, number> = {};
    activeColumns.forEach((col) => {
      if (col.field || col.name === '실수령액' || col.name === '임금합계') totalsMap[excelColTotalKey(col)] = 0;
    });

    sortedData.value.forEach((row, index) => {
      const grossPay = getReportRowGrossPay(row);
      const netPay = getRowNetPay(row);
      const remarkText = calculateAge(row.birth, props.year, props.month);

      const rowData = activeColumns.map((col) => {
        if (col.name === '순번') return index + 1;
        if (col.name === '성명') return row.name || '';
        if (col.name === '생년월일') return row.birth ? row.birth.substring(0, 10) : '';
        if (col.name === '직종') return row.job || '';
        if (col.name === '임금합계') return grossPay;
        if (col.name === '실수령액') return netPay;
        if (col.name === '비고') return remarkText;
        if (col.field === 'hour') return formatWorkHoursCell(row.hour) || '0';
        if (col.field) return getFieldValue(row, col.field);
        return '';
      });

      const dataRow = worksheet.addRow(rowData);
      const basicEnd = basicRange?.end || 4;
      const remarkStart = remarkRange?.start || activeColumns.length;

      dataRow.eachCell((cell, colNumber) => {
        const col = activeColumns[colNumber - 1];
        cell.alignment = {
          horizontal: colNumber <= basicEnd ? 'center' : 'right',
          vertical: 'middle',
        };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (colNumber > basicEnd && colNumber < remarkStart && col?.field !== 'hour') {
          cell.numFmt = '#,##0';
        }
        if (col?.field && col.field !== 'hour') {
          const key = excelColTotalKey(col);
          totalsMap[key] = (totalsMap[key] || 0) + getFieldValue(row, col.field);
        }
        if (col?.name === '임금합계') totalsMap['임금합계'] = (totalsMap['임금합계'] || 0) + grossPay;
        if (col?.name === '실수령액') totalsMap['실수령액'] = (totalsMap['실수령액'] || 0) + netPay;
      });
    });

    const totalRowData = activeColumns.map((col) => {
      if (col.name === '순번') return '';
      if (col.name === '성명') return '합계';
      if (col.name === '생년월일' || col.name === '직종' || col.name === '비고') return '';
      return totalsMap[excelColTotalKey(col)] || 0;
    });

    const totalRow = worksheet.addRow(totalRowData);
    const basicEnd = basicRange?.end || 4;
    const remarkStart = remarkRange?.start || activeColumns.length;
    totalRow.eachCell((cell, colNumber) => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF2CC' } };
      cell.font = { bold: true, size: 10 };
      cell.alignment = { horizontal: colNumber <= basicEnd ? 'center' : 'right', vertical: 'middle' };
      cell.border = {
        top: { style: 'medium' },
        left: { style: 'thin' },
        bottom: { style: 'medium' },
        right: { style: 'thin' },
      };
      if (colNumber > basicEnd && colNumber < remarkStart) {
        cell.numFmt = '#,##0';
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, formatReportFileName(props.memberName, props.year, props.month));
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : '알 수 없는 오류';
    console.error('임금대장 다운로드 오류:', error);
    emit('error', `임금대장 다운로드 중 오류가 발생했습니다: ${message}`);
  } finally {
    isDownloading.value = false;
  }
};

__expose({
  downloadPayrollReport,
  downloadClientReport,
  openPreview,
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "home-wage-report-modal-overlay",
          onClick: _withModifiers(closePreview, ["self"])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", null, _toDisplayString(reportModalTitle.value), 1),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "download-btn",
                  onClick: handleDownload,
                  disabled: isDownloading.value
                }, [
                  (isDownloading.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        size: "16",
                        class: "spin"
                      }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode("mdi-loading", -1)
                        ]))]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        size: "16"
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("mdi-download", -1)
                        ]))]),
                        _: 1
                      })),
                  _createTextVNode(" " + _toDisplayString(isDownloading.value ? '다운로드 중...' : '엑셀 다운로드'), 1)
                ], 8, _hoisted_4),
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: closePreview
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_8, [
                      _cache[3] || (_cache[3] = _createElementVNode("th", {
                        colspan: "4",
                        class: "section-basic"
                      }, "기본정보", -1)),
                      _cache[4] || (_cache[4] = _createElementVNode("th", {
                        colspan: "3",
                        class: "section-work"
                      }, "근로정보", -1)),
                      _createElementVNode("th", {
                        colspan: wageColspan.value,
                        class: "section-wage"
                      }, "임금구성", 8, _hoisted_9),
                      _createElementVNode("th", {
                        colspan: empDeductColspan.value,
                        class: "section-emp-deduct"
                      }, "근로자공제", 8, _hoisted_10),
                      _cache[5] || (_cache[5] = _createElementVNode("th", { class: "section-net" }, "수령", -1)),
                      _createElementVNode("th", {
                        colspan: corpDeductColspan.value,
                        class: "section-corp-deduct"
                      }, "기관공제", 8, _hoisted_11)
                    ]),
                    _createElementVNode("tr", _hoisted_12, [
                      _cache[6] || (_cache[6] = _createElementVNode("th", null, "순번", -1)),
                      _cache[7] || (_cache[7] = _createElementVNode("th", null, "성명", -1)),
                      _cache[8] || (_cache[8] = _createElementVNode("th", null, "생년월일", -1)),
                      _cache[9] || (_cache[9] = _createElementVNode("th", null, "직종", -1)),
                      _cache[10] || (_cache[10] = _createElementVNode("th", null, "시급", -1)),
                      _cache[11] || (_cache[11] = _createElementVNode("th", null, "일수", -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("th", null, "시간", -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("th", null, "기본급", -1)),
                      (showColumns.value.weekend)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_13, "주휴"))
                        : _createCommentVNode("", true),
                      (showColumns.value.annual)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_14, "연차"))
                        : _createCommentVNode("", true),
                      (showColumns.value.laborDay)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_15, "노동절"))
                        : _createCommentVNode("", true),
                      (reportType.value === 'accounting')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            (showColumns.value.premiumTax)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_16, "연야휴과세"))
                              : _createCommentVNode("", true),
                            (showColumns.value.premiumNontax)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_17, "연야휴비과세"))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            (showClientColumns.value.overtimeTotal)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_18, "연장"))
                              : _createCommentVNode("", true),
                            (showClientColumns.value.nightTotal)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_19, "야간"))
                              : _createCommentVNode("", true),
                            (showClientColumns.value.holidayTotal)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_20, "휴일"))
                              : _createCommentVNode("", true)
                          ], 64)),
                      (showColumns.value.senior)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_21, "장기"))
                        : _createCommentVNode("", true),
                      (showColumns.value.sunim)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_22, "선임"))
                        : _createCommentVNode("", true),
                      (showColumns.value.bosu)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_23, "보수"))
                        : _createCommentVNode("", true),
                      (showColumns.value.severe)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_24, "중증"))
                        : _createCommentVNode("", true),
                      (showColumns.value.bonus)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_25, "상여"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lunch)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_26, _toDisplayString(_unref(HOME_WAGE_NONTAX_TERM).lunch), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.car)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_27, _toDisplayString(_unref(HOME_WAGE_NONTAX_TERM).car), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.child)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_28, _toDisplayString(_unref(HOME_WAGE_NONTAX_TERM).child), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.welfare)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_29, "처우"))
                        : _createCommentVNode("", true),
                      (showColumns.value.other)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_30, "기타"))
                        : _createCommentVNode("", true),
                      _cache[14] || (_cache[14] = _createElementVNode("th", { class: "total-col" }, "임금합계", -1)),
                      (showColumns.value.lYeon)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_31, "국민연금"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lGun)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_32, "건강보험"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJang)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_33, "장기요양"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lGo)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_34, "고용보험"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lSo)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_35, "소득세"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJi)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_36, "지방세"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJiwon)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_37, "지원공제"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lBonin)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_38, "본인부담"))
                        : _createCommentVNode("", true),
                      (showColumns.value.lEtc)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_39, "기타공제"))
                        : _createCommentVNode("", true),
                      _cache[15] || (_cache[15] = _createElementVNode("th", { class: "total-col" }, "공제합계", -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("th", { class: "net-col" }, "실수령액", -1)),
                      (showColumns.value.cYeon)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_40, "국민연금"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cGun)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_41, "건강보험"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cJang)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_42, "장기요양"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cGo)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_43, "고용보험"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cSil)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_44, "실업급여"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cSan)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_45, "산재보험"))
                        : _createCommentVNode("", true),
                      (showColumns.value.cOut)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_46, "퇴직금"))
                        : _createCommentVNode("", true),
                      _cache[17] || (_cache[17] = _createElementVNode("th", { class: "total-col" }, "기관합계", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedData.value, (row, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: `${row.name}|${row.birth}`,
                        class: "data-row"
                      }, [
                        _createElementVNode("td", _hoisted_47, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", _hoisted_48, _toDisplayString(row.name), 1),
                        _createElementVNode("td", _hoisted_49, _toDisplayString(row.birth?.substring(0, 10)), 1),
                        _createElementVNode("td", _hoisted_50, _toDisplayString(row.job), 1),
                        _createElementVNode("td", _hoisted_51, _toDisplayString(formatNumber(row.payCalcHourly)), 1),
                        _createElementVNode("td", _hoisted_52, _toDisplayString(row.days), 1),
                        _createElementVNode("td", _hoisted_53, _toDisplayString(formatWorkHoursCell(row.hour)), 1),
                        _createElementVNode("td", _hoisted_54, _toDisplayString(formatNumber(getDisplayBasic(row))), 1),
                        (showColumns.value.weekend)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString(formatNumber(getDisplayWeekend(row))), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.annual)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_56, _toDisplayString(formatNumber(getDisplayAnnual(row))), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.laborDay)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_57, _toDisplayString(formatNumber(getDisplayLaborDay(row))), 1))
                          : _createCommentVNode("", true),
                        (reportType.value === 'accounting')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (showColumns.value.premiumTax)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_58, _toDisplayString(formatNumber(getAccountingPremiumTax(row))), 1))
                                : _createCommentVNode("", true),
                              (showColumns.value.premiumNontax)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_59, _toDisplayString(formatNumber(getAccountingPremiumNontax(row))), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              (showClientColumns.value.overtimeTotal)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_60, _toDisplayString(formatNumber(getDisplayOvertimeTotal(row))), 1))
                                : _createCommentVNode("", true),
                              (showClientColumns.value.nightTotal)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_61, _toDisplayString(formatNumber(getDisplayNight(row))), 1))
                                : _createCommentVNode("", true),
                              (showClientColumns.value.holidayTotal)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_62, _toDisplayString(formatNumber(getDisplayHoliday(row))), 1))
                                : _createCommentVNode("", true)
                            ], 64)),
                        (showColumns.value.senior)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_63, _toDisplayString(formatNumber(isClientReport() ? getClientAllowance(row, 'senior') : getAdminParts(row).senior)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.sunim)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_64, _toDisplayString(formatNumber(isClientReport() ? getClientAllowance(row, 'sunim') : getAdminParts(row).sunim)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.bosu)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_65, _toDisplayString(formatNumber(isClientReport() ? getClientAllowance(row, 'bosu') : getAdminParts(row).bosu)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.severe)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_66, _toDisplayString(formatNumber(getDisplaySevere(row))), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.bonus)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_67, _toDisplayString(formatNumber(isClientReport() ? getClientAllowance(row, 'bonus') : getAdminParts(row).bonus)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lunch)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_68, _toDisplayString(formatNumber(getDisplayLunch(row))), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.car)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_69, _toDisplayString(formatNumber(isClientReport() ? getClientAllowance(row, 'car') : getAdminParts(row).car)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.child)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_70, _toDisplayString(formatNumber(isClientReport() ? getClientAllowance(row, 'child') : getAdminParts(row).child)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.welfare)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_71, _toDisplayString(formatNumber(isClientReport() ? getClientAllowance(row, 'welfare') : getAdminParts(row).welfare)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.other)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_72, _toDisplayString(formatNumber(isClientReport() ? getClientAllowance(row, 'other') : getAdminParts(row).other)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", {
                          class: _normalizeClass(["right total-col", { 'total-mismatch': rowWageMismatch(row) }]),
                          title: rowWageMismatch(row) ? '항목 합과 임금합계가 일치하지 않습니다' : undefined
                        }, _toDisplayString(formatNumber(getReportRowGrossPay(row))), 11, _hoisted_73),
                        (showColumns.value.lYeon)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_74, _toDisplayString(formatNumber(row.l_yeon)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lGun)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_75, _toDisplayString(formatNumber(row.l_gun)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lJang)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_76, _toDisplayString(formatNumber(row.l_jang)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lGo)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_77, _toDisplayString(formatNumber(row.l_go)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lSo)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_78, _toDisplayString(formatNumber(row.l_so)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lJi)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_79, _toDisplayString(formatNumber(row.l_ji)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lJiwon)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_80, _toDisplayString(formatNumber(row.l_jiwon)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lBonin)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_81, _toDisplayString(formatNumber(row.l_bonin)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.lEtc)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_82, _toDisplayString(formatNumber(row.l_etc)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", {
                          class: _normalizeClass(["right total-col", { 'total-mismatch': rowLaborMismatch(row) }]),
                          title: rowLaborMismatch(row) ? '근로자공제 항목 합과 공제합계가 일치하지 않습니다' : undefined
                        }, _toDisplayString(formatNumber(row.l_total)), 11, _hoisted_83),
                        _createElementVNode("td", _hoisted_84, _toDisplayString(formatNumber(getRowNetPay(row))), 1),
                        (showColumns.value.cYeon)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_85, _toDisplayString(formatNumber(row.c_yeon)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cGun)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_86, _toDisplayString(formatNumber(row.c_gun)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cJang)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_87, _toDisplayString(formatNumber(row.c_jang)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cGo)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_88, _toDisplayString(formatNumber(row.c_go)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cSil)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_89, _toDisplayString(formatNumber(row.c_sil)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cSan)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_90, _toDisplayString(formatNumber(row.c_san)), 1))
                          : _createCommentVNode("", true),
                        (showColumns.value.cOut)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_91, _toDisplayString(formatNumber(getReportRetirement(row))), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", {
                          class: _normalizeClass(["right total-col", { 'total-mismatch': rowCorpMismatch(row) }]),
                          title: rowCorpMismatch(row) ? '기관공제 항목 합과 기관합계가 일치하지 않습니다' : undefined
                        }, _toDisplayString(formatNumber(getReportCorpTotal(row))), 11, _hoisted_92)
                      ]))
                    }), 128)),
                    _createElementVNode("tr", _hoisted_93, [
                      _cache[18] || (_cache[18] = _createElementVNode("td", {
                        class: "center",
                        colspan: "4"
                      }, "합계", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("td", {
                        class: "right",
                        colspan: "3"
                      }, null, -1)),
                      _createElementVNode("td", _hoisted_94, _toDisplayString(formatNumber(displayBasicTotal.value)), 1),
                      (showColumns.value.weekend)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_95, _toDisplayString(formatNumber(totals.value.weekend)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.annual)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_96, _toDisplayString(formatNumber(displayAnnualTotal.value)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.laborDay)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_97, _toDisplayString(formatNumber(totals.value.laborDay)), 1))
                        : _createCommentVNode("", true),
                      (reportType.value === 'accounting')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            (showColumns.value.premiumTax)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_98, _toDisplayString(formatNumber(totals.value.premiumTax)), 1))
                              : _createCommentVNode("", true),
                            (showColumns.value.premiumNontax)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_99, _toDisplayString(formatNumber(totals.value.premiumNontax)), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            (showClientColumns.value.overtimeTotal)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_100, _toDisplayString(formatNumber(displayOvertimeTotal.value)), 1))
                              : _createCommentVNode("", true),
                            (showClientColumns.value.nightTotal)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_101, _toDisplayString(formatNumber(displayNightTotal.value)), 1))
                              : _createCommentVNode("", true),
                            (showClientColumns.value.holidayTotal)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_102, _toDisplayString(formatNumber(displayHolidayTotal.value)), 1))
                              : _createCommentVNode("", true)
                          ], 64)),
                      (showColumns.value.senior)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_103, _toDisplayString(formatNumber(totals.value.senior)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.sunim)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_104, _toDisplayString(formatNumber(totals.value.sunim)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.bosu)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_105, _toDisplayString(formatNumber(totals.value.bosu)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.severe)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_106, _toDisplayString(formatNumber(totals.value.severe)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.bonus)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_107, _toDisplayString(formatNumber(totals.value.bonus)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lunch)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_108, _toDisplayString(formatNumber(totals.value.lunch)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.car)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_109, _toDisplayString(formatNumber(totals.value.car)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.child)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_110, _toDisplayString(formatNumber(totals.value.child)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.welfare)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_111, _toDisplayString(formatNumber(totals.value.welfare)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.other)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_112, _toDisplayString(formatNumber(totals.value.other)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", {
                        class: _normalizeClass(["right total-col", { 'total-mismatch': footerMismatch.value.wage }]),
                        title: footerMismatch.value.wage ? '임금 항목 합과 임금합계가 일치하지 않습니다' : undefined
                      }, _toDisplayString(formatNumber(totals.value.grossPay)), 11, _hoisted_113),
                      (showColumns.value.lYeon)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_114, _toDisplayString(formatNumber(totals.value.lYeon)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lGun)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_115, _toDisplayString(formatNumber(totals.value.lGun)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJang)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_116, _toDisplayString(formatNumber(totals.value.lJang)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lGo)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_117, _toDisplayString(formatNumber(totals.value.lGo)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lSo)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_118, _toDisplayString(formatNumber(totals.value.lSo)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJi)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_119, _toDisplayString(formatNumber(totals.value.lJi)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lJiwon)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_120, _toDisplayString(formatNumber(totals.value.lJiwon)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lBonin)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_121, _toDisplayString(formatNumber(totals.value.lBonin)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.lEtc)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_122, _toDisplayString(formatNumber(totals.value.lEtc)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", {
                        class: _normalizeClass(["right total-col", { 'total-mismatch': footerMismatch.value.labor }]),
                        title: footerMismatch.value.labor ? '근로자공제 합계가 일치하지 않습니다' : undefined
                      }, _toDisplayString(formatNumber(totals.value.lTotal)), 11, _hoisted_123),
                      _createElementVNode("td", _hoisted_124, _toDisplayString(formatNumber(totals.value.netPay)), 1),
                      (showColumns.value.cYeon)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_125, _toDisplayString(formatNumber(totals.value.cYeon)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cGun)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_126, _toDisplayString(formatNumber(totals.value.cGun)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cJang)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_127, _toDisplayString(formatNumber(totals.value.cJang)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cGo)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_128, _toDisplayString(formatNumber(totals.value.cGo)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cSil)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_129, _toDisplayString(formatNumber(totals.value.cSil)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cSan)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_130, _toDisplayString(formatNumber(totals.value.cSan)), 1))
                        : _createCommentVNode("", true),
                      (showColumns.value.cOut)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_131, _toDisplayString(formatNumber(totals.value.cOut)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", {
                        class: _normalizeClass(["right total-col", { 'total-mismatch': footerMismatch.value.corp }]),
                        title: footerMismatch.value.corp ? '기관공제 합계가 일치하지 않습니다' : undefined
                      }, _toDisplayString(formatNumber(totals.value.cTotal)), 11, _hoisted_132)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})